/**
 * Хук для работы с аутентификацией: login, logout, получение текущего пользователя и токена
 * Дата: 05.02.2026 - TODO-054: добавлен loginWithOTP для OTP авторизации
 */
import { useAuthStore } from '@/store/authStore';
import { authApi } from '@/api/auth';
import { LoginRequest, OTPVerifyRequest } from '@/api/types';

export function useAuth() {
  const { token, user, permissions, isAuthenticated, setAuth, logout: logoutStore } = useAuthStore();

  const login = async (credentials: LoginRequest) => {
    const response = await authApi.login(credentials);
    setAuth(response.token, response.user, response.permissions);
    return response;
  };

  // TODO-054: OTP Login (05.02.2026)
  // Верифицирует OTP код и авторизует пользователя
  const loginWithOTP = async (data: OTPVerifyRequest) => {
    const response = await authApi.otpVerify(data);
    
    // OTP response содержит базовые данные о пользователе
    // Для полноты получаем permissions через /auth/me не нужно,
    // т.к. токен уже выдан с правильными claims
    // Permissions можно получить отдельным запросом если нужно
    const userWithRole = {
      id: response.user.id,
      username: response.user.username,
      full_name: response.user.full_name,
      tenant_id: response.user.tenant_id,
      role_id: '', // Будет заполнено при первом /auth/me
      role_name: '', // Будет заполнено при первом /auth/me
    };
    
    // Устанавливаем auth с пустыми permissions (будут подгружены при первом запросе)
    setAuth(response.token, userWithRole, []);
    
    return response;
  };

  const logout = async () => {
    try {
      await authApi.logout();
    } catch (error) {
      // Игнорируем ошибки при logout
    } finally {
      logoutStore();
    }
  };

  return {
    token,
    user,
    permissions,
    isAuthenticated,
    login,
    loginWithOTP, // TODO-054
    logout,
  };
}

